export { default } from "./TopAndTabBarContainer.styled";
